// extracted by mini-css-extract-plugin
module.exports = {"container":"Reusable_container__M5WlU","spanElement":"Reusable_spanElement__31k4v","pElement":"Reusable_pElement__13jKA","secondSpan":"Reusable_secondSpan__1BdjI"};